// 検索結果がない時
function NoResults(props){
  return(
    <div className="mx-auto md:my-24 my-10 relative fit-content text-center">
      <img src="/images/no-results.png" className="md:h-40 h-32"/>
      <span className="text-gray-600 font-bold mt-3 block">{props.children}</span>
    </div>
  )
}
export default NoResults